<skip-nav></skip-nav>
@if (showDefaultNav) {
  <dec-desktop-menu [data]="menuData" [secondaryLogo]="secondaryLogo"></dec-desktop-menu>
}
